import { useCallback, useEffect, useRef, useState } from "react";
import { getFunctions, httpsCallable } from "firebase/functions";
import { auth } from "../firebase";
import "./ComunicadosAdmin.css";

const fns = getFunctions(undefined, "us-central1");
const enviar = httpsCallable(fns, "enviarComunicadoApp");
const listar = httpsCallable(fns, "listarComunicadosApp");
const estados = { pendente: "Na fila", processando: "Enviando", tentando_novamente: "Tentando novamente", concluido: "Concluído", concluido_com_falhas: "Concluído com falhas" };
const erroEnvio = e => e.code === "functions/not-found" ? "O serviço de comunicados ainda precisa ser publicado no Firebase." : e.message || "Não foi possível concluir. Tente novamente.";

export default function ComunicadosAdmin() {
  const [titulo, setTitulo] = useState("");
  const [mensagem, setMensagem] = useState("");
  const [publico, setPublico] = useState("todos");
  const [uid, setUid] = useState("");
  const [usuarios, setUsuarios] = useState([]);
  const [busca, setBusca] = useState("");
  const [revisao, setRevisao] = useState(null);
  const [ocupado, setOcupado] = useState(false);
  const [erro, setErro] = useState("");
  const [aviso, setAviso] = useState("");
  const [envios, setEnvios] = useState([]);
  const [erroHistorico, setErroHistorico] = useState("");
  const [carregandoHistorico, setCarregandoHistorico] = useState(true);
  const [carregandoUsuarios, setCarregandoUsuarios] = useState(false);
  const trava = useRef(false);
  const carregar = useCallback(async () => {
    setCarregandoHistorico(true);
    try { const r = await listar(); setEnvios(r.data.envios || []); setErroHistorico(""); }
    catch (e) { setErroHistorico(erroEnvio(e)); }
    finally { setCarregandoHistorico(false); }
  }, []);
  useEffect(() => { carregar(); }, [carregar]);
  const emAndamento = envios.some(e => !e.estado.startsWith("concluido"));
  useEffect(() => {
    if (!emAndamento) return;
    const timer = setInterval(carregar, 15000);
    return () => clearInterval(timer);
  }, [emAndamento, carregar]);

  async function carregarUsuarios() {
    setCarregandoUsuarios(true); setErro("");
    try {
      const token = await auth.currentUser?.getIdToken();
      if (!token) throw new Error("Entre novamente na conta de administrador.");
      const r = await fetch("https://us-central1-matriz3dsite.cloudfunctions.net/listarUsuarios", { headers: { Authorization: `Bearer ${token}` } });
      if (!r.ok) throw new Error("Não foi possível carregar os usuários. Tente atualizar a lista.");
      const data = await r.json();
      setUsuarios((data.users || []).filter(u => !u.semDocumento && !u.semConta && !["deleted", "banned"].includes(u.plan)));
    } catch (e) { setErro(erroEnvio(e)); }
    finally { setCarregandoUsuarios(false); }
  }
  function revisar(e) {
    e.preventDefault(); setErro(""); setAviso("");
    const usuario = usuarios.find(u => u.uid === uid);
    if (!titulo.trim() || !mensagem.trim() || (publico === "usuario" && !usuario)) {
      setErro("Preencha o título, a mensagem e selecione o destinatário."); return;
    }
    setRevisao({ titulo: titulo.trim(), mensagem: mensagem.trim(), publico, ...(publico === "usuario" ? { uid } : {}),
      requestId: crypto.randomUUID(), destinatario: usuario?.email || usuario?.nome || uid });
  }
  async function confirmar() {
    if (trava.current || !revisao) return;
    trava.current = true; setOcupado(true); setErro("");
    try {
      const { destinatario, ...payload } = revisao;
      await enviar({ ...payload, confirmado: true });
      setAviso("Comunicado enfileirado. Acompanhe o processamento no histórico abaixo.");
      setRevisao(null); setTitulo(""); setMensagem(""); await carregar();
    } catch (e) { setErro(`${erroEnvio(e)} Ao tentar novamente nesta revisão, o mesmo envio será reutilizado.`); }
    finally { trava.current = false; setOcupado(false); }
  }
  const filtrados = usuarios.filter(u => `${u.nome || ""} ${u.email || ""} ${u.empresa || ""}`.toLowerCase().includes(busca.toLowerCase()));
  return <div className="pc-comunicados">
    <header><h2>Comunicados do app</h2><p>Notificações na central do celular. Só recebe quem tem um aparelho registrado e notificações permitidas. Para conversar ou enviar e-mail, use o Suporte.</p></header>
    <form onSubmit={revisar}>
      <h3>Novo comunicado</h3>
      <fieldset disabled={!!revisao || ocupado}>
        <label>Público<select value={publico} onChange={e => { setPublico(e.target.value); if (e.target.value === "usuario" && !usuarios.length) carregarUsuarios(); }}>
          <option value="todos">Todos os usuários (exceto banidos e excluídos)</option><option value="usuario">Um usuário</option>
        </select></label>
        {publico === "usuario" && <>
          <label>Buscar usuário<input value={busca} onChange={e => setBusca(e.target.value)} placeholder="Nome, e-mail ou empresa" /></label>
          <label>Destinatário<select value={uid} onChange={e => setUid(e.target.value)} required>
            <option value="">{carregandoUsuarios ? "Carregando…" : "Selecione um usuário"}</option>
            {usuarios.filter(u => filtrados.includes(u) || u.uid === uid).map(u => <option key={u.uid} value={u.uid}>{u.nome || u.empresa || "Usuário"} — {u.email}</option>)}
          </select></label>
          <button type="button" disabled={carregandoUsuarios} onClick={carregarUsuarios}>Atualizar usuários</button>
        </>}
        <label>Título<input required maxLength={80} value={titulo} onChange={e => setTitulo(e.target.value)} /></label>
        <label>Mensagem<textarea required maxLength={500} rows={4} value={mensagem} onChange={e => setMensagem(e.target.value)} /><small>{mensagem.length}/500 caracteres</small></label>
        <button className="principal" type="submit">Revisar envio</button>
      </fieldset>
    </form>
    <aside className="comunicado-preview" aria-label="Prévia no celular"><span className="comunicado-eyebrow">PRÉVIA DA NOTIFICAÇÃO</span><div className="comunicado-phone"><div className="comunicado-phone-clock">09:41</div><div className="previa"><small>PRINT CONTROL · AGORA</small><h4>{titulo.trim() || "Título do comunicado"}</h4><p>{mensagem.trim() || "Sua mensagem aparece aqui. Seja claro e direto para facilitar a leitura no celular."}</p></div></div><p>Prévia ilustrativa. A aparência varia conforme o aparelho e suas configurações.</p></aside>
    {revisao && <section className="revisao" aria-label="Revisão do comunicado">
      <h3>Revise antes de enviar</h3><p>Destino: <strong>{revisao.publico === "todos" ? "TODOS os usuários, exceto banidos e excluídos" : revisao.destinatario}</strong></p>
      <div className="previa"><small>PRINT CONTROL · COMUNICADO</small><h4>{revisao.titulo}</h4><p>{revisao.mensagem}</p></div>
      <p>Após confirmar, o envio não pode ser cancelado.</p>
      <div className="acoes"><button disabled={ocupado} onClick={() => { setRevisao(null); setErro(""); }}>Voltar e editar</button><button className="principal" disabled={ocupado} onClick={confirmar}>{ocupado ? "Enfileirando…" : revisao.publico === "todos" ? "Confirmar envio para todos" : "Confirmar envio individual"}</button></div>
    </section>}
    {erro && <p role="alert" className="erro">{erro}</p>}{aviso && <p role="status">{aviso}</p>}
    <section className="comunicado-history"><div className="acoes"><h3>Histórico recente</h3><button disabled={carregandoHistorico} onClick={carregar}>{carregandoHistorico ? "Atualizando…" : "Atualizar histórico"}</button></div>
      <p>Últimos 30 envios. Atualização a cada 15 segundos enquanto houver processamento.</p>
      <p>“Aceitas” indica notificações aceitas pelo serviço de envio, não leitura nem entrega confirmada no aparelho.</p>
      {erroHistorico && <p role="alert" className="erro">{erroHistorico}</p>}
      {!envios.length && !erroHistorico && !carregandoHistorico && <p>Nenhum comunicado enviado.</p>}
      {envios.map(e => <article key={e.id}><div className="acoes"><strong>{e.titulo}</strong><span>{estados[e.estado] || e.estado}</span></div><p>{e.mensagem}</p><small>{new Date(e.criadoEm).toLocaleString("pt-BR")} · {e.publico === "todos" ? "Todos os usuários" : "Individual"}</small><p>{e.usuarios} usuários processados · {e.enviados} aceitas · {e.falhas} falhas · {e.semDispositivo} sem aparelho</p></article>)}
    </section>
  </div>;
}
